import { render, staticRenderFns } from "./ErrorHandler.vue?vue&type=template&id=66e9b858&scoped=true"
import script from "./ErrorHandler.vue?vue&type=script&setup=true&lang=ts"
export * from "./ErrorHandler.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ErrorHandler.vue?vue&type=style&index=0&id=66e9b858&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e9b858",
  null
  
)

export default component.exports